import React from 'react'
import { Flex, Label, Input, Button, Table, useDebounce } from '@fareye/ui'
import { FaDownload, isEmpty, dMmm } from '@fareye/utils'
import { downloadToCSV, useTranslation } from '@fareye/common'

import { getTableColumns } from './Column'
import { tripTabsBackground, modeBackground } from '@fareye/configs'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: modeBackground,
    width: 'fit-content',
    marginBottom: '8px'
  }
}

export const PackageDetails = ({ config, data }: any) => {
  const { packageDetails = [] } = data
  const { startLocation, endLocation } = data

  const { t } = useTranslation()
  const {
    config: { packageColumns, links = {} }
  } = config
  const [searchInput, setSearchInput] = React.useState('')
  const debouncedSearchTerm = useDebounce(searchInput, 400)

  const [downloadLoading, setDownloadLoading] = React.useState(false)

  const [filteredData, setFilteredData] = React.useState([])

  const selectedColumn = React.useMemo(() => {
    return getTableColumns(packageColumns, { t, links })
  }, [])
  React.useEffect(() => {
    const validPackages = packageDetails.filter((item: any) => !!item?.packageId)
    setFilteredData(
      isEmpty(searchInput)
        ? validPackages
        : validPackages.filter((item: any) =>
            Object.values(item).some(v => v === searchInput)
          )
    )
  },[debouncedSearchTerm, packageDetails])
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Label style={{ fontSize: '16px', fontWeight: 600 }}>
          Package Details
        </Label>
        <Flex justifyContentSpaceBetween>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchInput(e.target.value)
            }
            placeholder={'Search Items'}
            style={{
              margin: '15px 0px 4px',

              fontSize: 12,
              lineHeight: 1,
              background: '#fff',
              borderColor: 'hsl(0,0%,80%)',
              color: 'rgba(151,151,151,1)'
            }}
          />
          <Button
            disabled={false}
            isLoading={false}
            variant="s primary"
            style={{ height: '30px', margin: '15px 0px 4px' }}
            onClick={() => {
              setDownloadLoading(true)
              downloadToCSV({
                data: packageDetails,
                fileName: `packageDetails_${dMmm()}`
              })
              setDownloadLoading(false)
            }}
          >
            Download CSV
            <FaDownload style={style.downloadIcon} />
          </Button>
        </Flex>
      </Flex>
      {!isEmpty(filteredData) ? (
        <Flex style={style.tripTabs} column>
          <Table
            className="striped responsive"
            totalElements={filteredData.length}
            sortable={false}
            showTotalCount={false}
            showPagination={false}
            data={filteredData}
            columns={selectedColumn}
          />
        </Flex>
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          No Data
        </Label>
      )}
    </Flex>
  )
}
